module.exports = __webpack_public_path__ + "img/dengji1.25b73a32.png";